import {Box, Stack, styled} from '@mui/material';

const StyledCardBox = styled(Box)`
	display: grid;
	place-content: center;
	background-color: ${({theme}) => theme.palette.primary.main};
	height: 268px;
	border-radius: 16px;
	color: ${({theme}) => theme.palette.other.progressBar};
`;

const StyledCardDetailsStack = styled(Stack)`
	gap: 16px;
	background-color: ${({theme}) => theme.palette.background.paper};
	border-radius: 16px;
	padding: 32px;
`;

export {StyledCardBox, StyledCardDetailsStack};
